<template>
  <v-container fluid class="full-height">
    <v-row>
      <v-col cols="12">
        <h2 class="text-center">Paywall Description Cards</h2>
      </v-col>
    </v-row>
    <v-row class="justify-center">
      <v-col cols="4">
        <div class="px-4">
          <v-select
            :items="[
              constantValue.WITHOUT_SPOUSE_GENERAL_PREVIEW,
              constantValue.WITHOUT_SPOUSE_LEVEL_ONE_PREVIEW,
              constantValue.WITHOUT_SPOUSE_LEVEL_TWO_PREVIEW,
             ]"
            label="Choose Card Preview"
            v-model="selectedCard"
            @input="selectedCardValuePreview"
            outlined
          ></v-select>
        </div>
        <CostInfo
          :show-select-btn="true"
          :image="currentCostInfoUnilateral?.img"
          :summary="currentCostInfoUnilateral?.summary"
          :tab="{ title: currentCostInfoUnilateral?.title, bg: currentCostInfoUnilateral?.bg, fg: currentCostInfoUnilateral?.fg }"
          :items="currentCostInfoUnilateral?.items"
          :tab-items="[
              constantValue.WITHOUT_SPOUSE_GENERAL_PREVIEW,
              constantValue.WITHOUT_SPOUSE_LEVEL_ONE_PREVIEW,
              constantValue.WITHOUT_SPOUSE_LEVEL_TWO_PREVIEW
              ]"
          :unilateral-pricing-levels="currentCostInfoUnilateral?.unilateralPricingLevels"
          nameProp="unilateral"
          :preview-choice="currentCostInfoUnilateral?.previewChoice"
          btn-name="Edit card"
          @dialogAction="editForm"
        />
      </v-col>
      <v-col cols="4">
        <div class="px-4">
          <v-select
            :items="[
              constantValue.WITH_SPOUSE_GENERAL_PREVIEW,
              constantValue.WITH_SPOUSE_LEVEL_ONE_PREVIEW,
              constantValue.WITH_SPOUSE_LEVEL_TWO_PREVIEW
              ]"
            label="Choose Card Preview"
            v-model="selectedColCard"
            @input="selectedColCardValuePreview"
            outlined
          ></v-select>
        </div>
        <CostInfo
          :show-select-btn="true"
          :image="currentCostInfoCollaborative?.img"
          :summary="currentCostInfoCollaborative?.summary"
          :tab="{ title: currentCostInfoCollaborative?.title, bg: currentCostInfoCollaborative?.bg, fg: currentCostInfoCollaborative?.fg }"
          :items="currentCostInfoCollaborative?.items"
          :tab-items="[
            constantValue.WITH_SPOUSE_GENERAL_PREVIEW,
            constantValue.WITH_SPOUSE_LEVEL_ONE_PREVIEW,
            constantValue.WITH_SPOUSE_LEVEL_TWO_PREVIEW]"
          :collaborative-pricing-levels="collaborativePricing"
          nameProp="collaborative"
          btn-name="Edit card"
          :preview-choice="currentCostInfoCollaborative?.previewChoice"
          @dialogAction="editForm"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import paywallDescriptionCardsMixin from '@/mixins/paywallDescriptionCards.mixin';

export default {
  name: 'PaywallDescriptionCards',
  mixins: [paywallDescriptionCardsMixin],
};
</script>
